import React, { useEffect, useMemo } from 'react';
import { RouteComponentProps } from 'react-router';

import { ReviewTOSView as BaseReviewTOSView } from '../../common/ReviewTOSView';
import { useOrgOnboardingContext } from '../../../contexts/OrgOnboardingContext';
import { useUserOnboardingContext } from '../../../contexts/UserOnboardingContext';

export type ReviewTOSViewProps = RouteComponentProps<{ hash?: string }> & {
  goBackStep: (isClaimed: boolean, isApprover: boolean) => () => void | null;
};

const ReviewTOSView = (props: ReviewTOSViewProps) => {
  const {
    goBackStep,
    match: {
      params: { hash },
    },
  } = props;
  const { getSearchParam } = useOrgOnboardingContext();
  const { newPassword, claimBrokerage } = useUserOnboardingContext();

  const isApprover = getSearchParam('approved') === 'true';
  const isClaimed = getSearchParam('isClaimed') === 'true';
  const verifyHash = getSearchParam('verifyHash');

  const handleGoBackStep = useMemo(
    () => goBackStep(isClaimed, isApprover),
    [isApprover, isClaimed, goBackStep],
  );

  useEffect(() => {
    // NOTE: password is NOT stored in localStorage, so will erase from state if ReviewTOS screen is refreshed/reloaded
    if (!isClaimed && !newPassword) {
      handleGoBackStep();
    }
  }, [handleGoBackStep, newPassword, isClaimed]);

  const handleSubmit = () => claimBrokerage(hash, { isClaimed, verifyHash });

  return (
    <BaseReviewTOSView
      handleGoBackStep={handleGoBackStep}
      handleSubmit={handleSubmit}
      {...props}
    />
  );
};

export default ReviewTOSView;
